module.exports = __webpack_public_path__ + "img/globe.d9fe5331.svg";